import { createRoot } from "react-dom/client"
import { RenderApp, AppError } from "./App"
import { SetupIcons } from "./Components/Icon"
import { installBridge } from "./App/Bridge"

installBridge();
SetupIcons();

const root = document.getElementById("root")!;
const reactRoot = createRoot(root);
window.addEventListener("error", (event) => {
  AppError(event.error, reactRoot);
});
document.documentElement.setAttribute("data-theme", localStorage.getItem("logbook-theme") || "dark");
RenderApp(reactRoot);
